import { useEffect } from 'react'
import { isOpenFinRuntime } from '../../containers/OpenFin/helpers'
import { startTabKeepAlive, stopTabKeepAlive } from '../../helpers/tabKeepAlive'
import { getAllPendingUserOrders } from '../../store/order/selectors'
import { useAppSelector } from '../../store/types'
import LastLookOpener from '../../containers/OpenFin/LastLookOpener'
import AggressorModalStack from '../Modal/AggressorModalStack/AggressorModalStack'
import RfqModalStack from '../Modal/RfqModalStack/RfqModalStack'
import styles from '../SecuritiesTable.module.scss'

export const AggressorAndLastLook = () => {
  const pendingOrders = useAppSelector(getAllPendingUserOrders)
  const hasPassiveOrders = pendingOrders.length > 0

  useEffect(() => {
    if (hasPassiveOrders && !isOpenFinRuntime()) {
      startTabKeepAlive()
    } else {
      stopTabKeepAlive()
    }
    return () => {
      stopTabKeepAlive()
    }
  }, [hasPassiveOrders])

  return (
    <div className={styles.aggressorAndLastLookwrapper}>
      <AggressorModalStack />
      <LastLookOpener />
      <RfqModalStack />
    </div>
  )
}
